
import { Package } from "lucide-react";

interface AppCatalogEmptyProps {
  searchTerm: string;
}

export const AppCatalogEmpty = ({ searchTerm }: AppCatalogEmptyProps) => {
  return (
    <div className="border rounded-lg p-8 text-center text-gray-500">
      <Package className="w-8 h-8 mx-auto mb-2 text-gray-400" />
      <p>{searchTerm ? `No apps found matching "${searchTerm}"` : "No apps found"}</p>
    </div>
  );
};
